import axios from "axios";
import { GUEST_VOTE_WEB_HEADERS } from "../utils/guestVote";

const adminBase = process.env.REACT_APP_API_URL;
const userBase = process.env.REACT_APP_API_URL_USER;

const auth = (token, extraHeaders = {}) => ({
  headers: { Authorization: `Bearer ${token}`, ...extraHeaders },
});

export const getAdminFinalNight = (id, token) =>
  axios.get(`${adminBase}/getAdminFinalNight/${id}`, auth(token));

export const startFinalNight = (data, token) =>
  axios.post(`${adminBase}/startFinalNight`, data, auth(token));

export const updateFinalNightSettings = (data, token) =>
  axios.post(`${adminBase}/updateFinalNightSettings`, data, auth(token));

export const updateFinalNightSetup = (data, token) =>
  axios.post(`${adminBase}/updateFinalNightSetup`, data, auth(token));

export const endFinalNight = (data, token) =>
  axios.post(`${adminBase}/endFinalNight`, data, auth(token));

export const enableFinalNightRound = (data, token) =>
  axios.post(`${adminBase}/enableFinalNightRound`, data, auth(token));

export const completeFinalNightRound = (data, token) =>
  axios.post(`${adminBase}/completeFinalNightRound`, data, auth(token));

export const eliminateContestants = (data, token) =>
  axios.post(`${adminBase}/eliminateContestants`, data, auth(token));

export const adjustContestantVotes = (data, token) =>
  axios.post(`${adminBase}/adjustContestantVotes`, data, auth(token));

export const advanceToNextRound = (data, token) =>
  axios.post(`${adminBase}/advanceToNextRound`, data, auth(token));

export const getFinalNightDetail = (id, token) =>
  axios.get(`${userBase}/getFinalNightDetail/${id}`, auth(token));

export const submitJudgeScores = (data, token) =>
  axios.post(`${userBase}/submitJudgeScores`, data, auth(token));

export const voteFinalNightContestant = (data, token, { isGuest = false } = {}) =>
  axios.post(
    `${userBase}/voteFinalNightContestant`,
    data,
    auth(token, isGuest ? GUEST_VOTE_WEB_HEADERS : {})
  );
